import { PrimaryButton } from "@fluentui/react/lib/Button";
import React, { useEffect, useState } from "react";
import { getUserSummaryList } from "../../actions/UserAction";
import Header from "../../component/common/Header";

function ProbationCompletion() {
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedReviewingAuth, setSelectedReviewingAuth] = useState(null);
  const [selectedReportingAuth, setSelectedReportingAuth] = useState(null);
  const [userInput, setUserInput] = useState({});

  useEffect(() => {
    getUserList();
  }, []);

  async function getUserList() {
    try {
      const { result } = await getUserSummaryList();
      setEmployees(result);
    } catch (e) {
      setEmployees([]);
    }
  }

  function onEmployeeSelect(e) {
    setSelectedEmployee(e[0]);
  }

  function onUserInput(field, value) {
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-2 px-0">
          <Header />
        </div>
        <div className="col-md-10 mt-3 flex flex-col items-center p-3">
          <div className="w-full">
            <p className="text-center font-semibold">
              Confidential Report for Completion of Probation Period
            </p>
          </div>
          <div className="mt-3 w-full flex-1 overflow-auto">
            <div className="flex items-center">
              <p className="mr-3 w-1/5">Professional Competence:</p>
              <input
                className="flex-1 h-11 shadow-sm rounded-md border border-black p-2 text-lg"
                onInput={(e) =>
                  onUserInput("professionalCompetence", e.target.value)
                }
              />
            </div>
            <div className="flex items-center mt-3">
              <p className="mr-3 w-1/5">Attitude and Co-Operation:</p>
              <div className="flex-1 flex justify-between">
                <div className="flex-1 flex flex-col mr-3">
                  <p className="mr-3">With Colleagues:</p>
                  <input
                    className="flex-1 flex h-11 shadow-sm rounded-md border border-black p-2 text-lg"
                    onInput={(e) =>
                      onUserInput("attitudeWithCollegues", e.target.value)
                    }
                  />
                </div>
                <div className="flex-1 flex flex-col">
                  <p className="mr-3">With Superiors:</p>
                  <input
                    className="flex-1 flex h-11 shadow-sm rounded-md border border-black p-2 text-lg"
                    onInput={(e) =>
                      onUserInput("attitudeWithSuperiors", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
            <div className="flex items-center mt-3">
              <p className="mr-3 w-1/5">Quality of Work:</p>
              <input
                className="flex-1 h-11 shadow-sm rounded-md border border-black p-2 text-lg"
                onInput={(e) => onUserInput("qualityOfWork", e.target.value)}
              />
            </div>
            <div className="flex items-center mt-3">
              <p className="mr-3 w-1/5">Dependability:</p>
              <input
                className="flex-1 h-11 shadow-sm rounded-md border border-black p-2 text-lg"
                onInput={(e) => onUserInput("dependability", e.target.value)}
              />
            </div>
            <div className="flex items-center mt-3">
              <p className="mr-3 w-1/5">Target Fixed:</p>
              <input
                className="flex-1 h-11 shadow-sm rounded-md border border-black p-2 text-lg"
                onInput={(e) => onUserInput("targetFixed", e.target.value)}
              />
            </div>
            <div className="flex items-center mt-3">
              <p className="mr-3 w-1/5">Target Achieved:</p>
              <input
                className="flex-1 h-11 shadow-sm rounded-md border border-black p-2 text-lg"
                onInput={(e) => onUserInput("targetAchieved", e.target.value)}
              />
            </div>
            <div className="flex items-center mt-3">
              <p className="mr-3 w-1/5">
                Whether Unauthorized/Leave without pay (LWP):
              </p>
              <input
                className="flex-1 h-11 shadow-sm rounded-md border border-black p-2 text-lg"
                onInput={(e) => onUserInput("lwp", e.target.value)}
              />
            </div>
            <div className="flex items-center mt-3">
              <p className="mr-3 w-1/5">
                Any Physical absence with any type of leave during probation
                period:
              </p>
              <input
                className="flex-1 h-11 shadow-sm rounded-md border border-black p-2 text-lg"
                onInput={(e) =>
                  onUserInput("leaveDuringProbation", e.target.value)
                }
              />
            </div>
            <div className="flex items-center mt-3">
              <p className="mr-3 w-1/5">
                Recommended to be confirmed or otherwise:
              </p>
              <input
                className="flex-1 h-11 shadow-sm rounded-md border border-black p-2 text-lg"
                onInput={(e) => onUserInput("recommended", e.target.value)}
              />
            </div>
            <div className="mt-3 flex justify-center">
              <PrimaryButton>Submit</PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProbationCompletion;
